import React from 'react';

interface DistributorIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const DistributorIcon: React.FC<DistributorIconProps> = ({
  width = 24,
  height = 24,
  color = '#313485',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.3334 22.5L18.4334 24.5L23.3334 19.8333M19.25 16.8021C18.9061 16.6034 18.5248 16.4614 18.1187 16.3884C18.0306 16.3726 17.9373 16.3613 17.8316 16.3533C17.5689 16.3333 17.4375 16.3234 17.2621 16.3365C17.0799 16.35 16.9782 16.368 16.8022 16.4177C16.6331 16.4654 16.3283 16.6034 15.7188 16.8796C14.839 17.2781 13.862 17.5 12.8334 17.5C11.8047 17.5 10.8278 17.2781 9.94798 16.8796C9.33836 16.6034 9.03354 16.4653 8.86432 16.4176C8.68842 16.368 8.58649 16.35 8.40423 16.3364C8.22888 16.3233 8.09761 16.3333 7.83506 16.3534C7.72767 16.3616 7.63294 16.3731 7.5432 16.3893C6.10684 16.6494 4.9827 17.7735 4.72266 19.2099C4.66669 19.519 4.66669 19.8899 4.66669 20.6314V22.6333C4.66669 23.2868 4.66669 23.6134 4.79384 23.863C4.9057 24.0826 5.08418 24.261 5.3037 24.3728C5.55326 24.5 5.87996 24.5 6.53335 24.5H12.25M17.5 8.16667C17.5 10.744 15.4106 12.8333 12.8334 12.8333C10.256 12.8333 8.16669 10.744 8.16669 8.16667C8.16669 5.58934 10.256 3.5 12.8334 3.5C15.4106 3.5 17.5 5.58934 17.5 8.16667Z"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DistributorIcon;
